// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreateBidContractMutationVariables = Types.Exact<{
  input: Types.SaveBidContractInput;
}>;


export type CreateBidContractMutation = { __typename?: 'Mutation', saveBidContract: { __typename?: 'SaveBidContractResult', bidContract: { __typename?: 'BidContract', id: string, unsignedRevision?: { __typename?: 'BidContractRevision', id: string } | null | undefined } } };

export type DevelopmentTradePartnersQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
}>;


export type DevelopmentTradePartnersQuery = { __typename?: 'Query', development: { __typename?: 'Development', id: string, bidContracts: Array<{ __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined }> } };


export const CreateBidContractDocument = gql`
    mutation CreateBidContract($input: SaveBidContractInput!) {
  saveBidContract(input: $input) {
    bidContract {
      id
      unsignedRevision {
        id
      }
    }
  }
}
    `;
export type CreateBidContractMutationFn = Apollo.MutationFunction<CreateBidContractMutation, CreateBidContractMutationVariables>;

/**
 * __useCreateBidContractMutation__
 *
 * To run a mutation, you first call `useCreateBidContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBidContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBidContractMutation, { data, loading, error }] = useCreateBidContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBidContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBidContractMutation, CreateBidContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBidContractMutation, CreateBidContractMutationVariables>(CreateBidContractDocument, options);
      }
export type CreateBidContractMutationHookResult = ReturnType<typeof useCreateBidContractMutation>;
export type CreateBidContractMutationResult = Apollo.MutationResult<CreateBidContractMutation>;
export type CreateBidContractMutationOptions = Apollo.BaseMutationOptions<CreateBidContractMutation, CreateBidContractMutationVariables>;
export const DevelopmentTradePartnersDocument = gql`
    query DevelopmentTradePartners($developmentId: ID!) {
  development(id: $developmentId) {
    id
    bidContracts {
      id
      tradePartner {
        id
      }
    }
  }
}
    `;

/**
 * __useDevelopmentTradePartnersQuery__
 *
 * To run a query within a React component, call `useDevelopmentTradePartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentTradePartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentTradePartnersQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *   },
 * });
 */
export function useDevelopmentTradePartnersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentTradePartnersQuery, DevelopmentTradePartnersQueryVariables> & ({ variables: DevelopmentTradePartnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentTradePartnersQuery, DevelopmentTradePartnersQueryVariables>(DevelopmentTradePartnersDocument, options);
      }
export function useDevelopmentTradePartnersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentTradePartnersQuery, DevelopmentTradePartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentTradePartnersQuery, DevelopmentTradePartnersQueryVariables>(DevelopmentTradePartnersDocument, options);
        }
export function useDevelopmentTradePartnersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentTradePartnersQuery, DevelopmentTradePartnersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentTradePartnersQuery, DevelopmentTradePartnersQueryVariables>(DevelopmentTradePartnersDocument, options);
        }
export type DevelopmentTradePartnersQueryHookResult = ReturnType<typeof useDevelopmentTradePartnersQuery>;
export type DevelopmentTradePartnersLazyQueryHookResult = ReturnType<typeof useDevelopmentTradePartnersLazyQuery>;
export type DevelopmentTradePartnersSuspenseQueryHookResult = ReturnType<typeof useDevelopmentTradePartnersSuspenseQuery>;
export type DevelopmentTradePartnersQueryResult = Apollo.QueryResult<DevelopmentTradePartnersQuery, DevelopmentTradePartnersQueryVariables>;